// BillingStatusCard.js
import BillingStatusPill from './BillingStatusPill';
import { formatBillingDate } from '../../utils/billingStatus';

function detailLine(s, nowMs) {
    if (s.status === 'trialing') return `Trial ends ${formatBillingDate(s.trialEndMs)} (${s.trialDaysLeft} day${s.trialDaysLeft === 1 ? '' : 's'} left)`;
    if (s.status === 'past_due' && s.trialExpired) {
        // A trial with no trial_ends_at is treated as expired (see effectiveStatus); there is no date to show.
        return s.trialEndMs ? `Trial ended ${formatBillingDate(s.trialEndMs)}` : 'Trial ended. New cases are paused.';
    }
    if (s.status === 'past_due') return 'Payment is overdue. New cases are paused.';
    if (s.status === 'canceled') {
        if (!s.periodEndMs) return 'Subscription canceled.';
        return s.periodEndMs > nowMs ? `Access ends ${formatBillingDate(s.periodEndMs)}` : `Access ended ${formatBillingDate(s.periodEndMs)}`;
    }
    if (s.status === 'manual') return 'Billed by invoice.';
    if (s.status === 'active') {
        if (s.overrideActive) return 'Access extended by CensusZen.';
        return s.cancelAtPeriodEnd ? `Cancels ${formatBillingDate(s.periodEndMs)}` : `Renews ${formatBillingDate(s.periodEndMs)}`;
    }
    return 'No billing on file for this agency.';
}

export default function BillingStatusCard({ summary, nowMs = Date.now() }) {
    return (
        <section className="billing-card">
            <h2 className="billing-card-title">Status</h2>
            <BillingStatusPill status={summary.status} trialExpired={summary.trialExpired} />
            <p className="billing-card-detail">{detailLine(summary, nowMs)}</p>
        </section>
    );
}
